module.exports = __webpack_public_path__ + "static/media/bk_swiper_c-10.5b74bdf8.png";